import { _pHttp } from "../_pHttp";

export async function addTicket(body: any) {
  await _pHttp.post(`/tickets`, body);
}

export const getTicketList = async ({ page, numberInPage, search, matchId }: any) => {
  const { data } = await _pHttp.get(
    `tickets/offline/matchId/${matchId}?page=${page}&numberInPage=${numberInPage}&search=${search}`
  );
  return data;
};
export const getTicketListWithTicketCountPerson = async ({ page, numberInPage, search,  }: any) => {
  const { data } = await _pHttp.get(
    `ticket-matches/with-ticket-count/offline?page=${page}&numberInPage=${numberInPage}&search=${search}`
  );
  return data;
};

export async function deleteTicketList(id: any) {
  return _pHttp.delete(`/tickets/${id}`);
}
